/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastadvertisingmaterialorderdate4Inputs */

const de__field_lastadvertisingmaterialorderdate4 = /** @type {(inputs: _Field_Lastadvertisingmaterialorderdate4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Werbematerial-Bestellung`)
};

/**

* @param {_Field_Lastadvertisingmaterialorderdate4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastadvertisingmaterialorderdate4 = /** @type {((inputs?: _Field_Lastadvertisingmaterialorderdate4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastadvertisingmaterialorderdate4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lastadvertisingmaterialorderdate4(inputs)
});
export { _field_lastadvertisingmaterialorderdate4 as "_field_lastAdvertisingMaterialOrderDate" }